import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowRight, Clock } from "lucide-react";
import { Layout } from "@/components/layout/Layout";
import { Seo } from "@/components/seo/Seo";
import { Button } from "@/components/ui/button";
import { BRAND } from "@/data/site";
import { breadcrumbSchema, orgSchema } from "@/lib/schema";

const ThankYou = () => (
  <Layout>
    <Seo
      title="Thank You for Contacting VRP Flooring LLC"
      description="Thank you for reaching out to VRP Flooring LLC in Danbury, CT. A member of our team will contact you shortly to discuss your flooring project."
      canonical={`${BRAND.website}/thank-you`}
      jsonLd={[orgSchema(), breadcrumbSchema([{ name: "Home", url: BRAND.website }, { name: "Thank You", url: `${BRAND.website}/thank-you` }])]}
    />
    <section className="container-page pt-10 pb-20 md:pt-12 md:pb-28">
      <div className="mx-auto max-w-3xl text-center">
        <h1 className="font-display text-4xl md:text-5xl font-bold mb-5">
          Thank You for Contacting {BRAND.legalName}
        </h1>
        <p className="text-muted-foreground text-lg mb-4">
          We've received your request. A member of our team will contact you as soon as possible to discuss your flooring project and the next steps.
        </p>
        <p className="text-muted-foreground">
          If your flooring need is urgent, reach out to us directly by phone or email — we answer 24/7.
        </p>
      </div>

      <div className="mx-auto mt-12 grid max-w-6xl gap-6 sm:grid-cols-2 xl:grid-cols-4">
        <div className="rounded-lg border border-border bg-card p-8 text-center">
          <Phone className="mx-auto mb-3 h-7 w-7 text-accent" />
          <div className="font-semibold mb-1">Phone</div>
          <a href={`tel:${BRAND.phone.replace(/\s/g, "")}`} className="text-muted-foreground hover:text-accent break-words">
            {BRAND.phoneDisplay}
          </a>
        </div>
        <div className="rounded-lg border border-border bg-card p-8 text-center">
          <Mail className="mx-auto mb-3 h-7 w-7 text-accent" />
          <div className="font-semibold mb-1">Email</div>
          <a href={`mailto:${BRAND.email}`} className="whitespace-nowrap text-sm text-muted-foreground hover:text-accent">
            {BRAND.email}
          </a>
        </div>
        <div className="rounded-lg border border-border bg-card p-8 text-center">
          <MapPin className="mx-auto mb-3 h-7 w-7 text-accent" />
          <div className="font-semibold mb-1">Address</div>
          <div className="text-muted-foreground text-sm">
            {BRAND.address.street}, {BRAND.address.city}, {BRAND.address.region} {BRAND.address.postalCode}
          </div>
        </div>
        <div className="rounded-lg border border-border bg-card p-8 text-center">
          <Clock className="mx-auto mb-3 h-7 w-7 text-accent" />
          <div className="font-semibold mb-1">Hours</div>
          <div className="text-muted-foreground text-sm">
            {BRAND.hours.map((h) => (
              <div key={h.day}>{h.day}: {h.time}</div>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-12 flex flex-col sm:flex-row gap-3 justify-center">
        <Button asChild size="lg" className="bg-accent text-accent-foreground hover:bg-accent/90 font-semibold">
          <Link to="/services">
            Explore Our Services <ArrowRight className="ml-1 h-4 w-4" />
          </Link>
        </Button>
        <Button asChild size="lg" variant="outline" className="font-semibold">
          <a href={`tel:${BRAND.phone.replace(/\s/g, "")}`}>
            <Phone className="mr-1 h-4 w-4" /> Call {BRAND.phoneDisplay}
          </a>
        </Button>
      </div>
    </section>
  </Layout>
);

export default ThankYou;
